import React from 'react'
import { accent, accentLight, borderDefault } from './styles'

function PlacementZone({ index, isSelected, onClick, label, disabled = false }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        padding: '8px 12px',
        border: `2px dashed ${isSelected ? accent : borderDefault}`,
        borderRadius: '8px',
        backgroundColor: isSelected ? accentLight : 'transparent',
        color: isSelected ? accent : '#9ca3af',
        fontSize: '0.85rem',
        fontWeight: '600',
        cursor: disabled ? 'wait' : 'pointer',
        opacity: disabled ? 0.55 : 1,
        minHeight: 44,
        marginBottom: '12px',
        width: '100%',
        transition: 'all 0.15s ease',
        fontFamily: 'inherit',
      }}
    >
      {label || '▼ Place here'}
    </button>
  )
}

export default PlacementZone
